const formElementAnnotatedStyle = {
  field: {
    maxWidth: 300,
    margin: "0 0 0 auto",
  },
};

export default formElementAnnotatedStyle;
